import type { JSX } from "react";
import { ToggleButton } from "./ui";

interface ClaimBenefitToggleProps {
  checked: boolean;
  onChange: (value: boolean) => void;
}

/**
 * ClaimBenefitToggle - wrapper around ToggleButton for child benefit claiming
 */
export function ClaimBenefitToggle({ checked, onChange }: ClaimBenefitToggleProps): JSX.Element {
  return (
    <ToggleButton
      checked={checked}
      onChange={onChange}
      label="Claim Child Benefit"
    />
  );
}